function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

import { defineComponent, openBlock, createElementBlock, normalizeClass, renderSlot, normalizeProps, guardReactiveProps, pushScopeId, popScopeId, nextTick, createBlock, withScopeId, resolveComponent, normalizeStyle, withKeys, createElementVNode, Fragment, createCommentVNode, withCtx, createVNode, mergeProps, toDisplayString, ref, createApp, h } from "vue";
import { offset, autoPlacement, shift, flip, arrow, size, computePosition, getScrollParents } from "@floating-ui/dom";

function assign(to, from) {
  for (var key in from) {
    if (Object.prototype.hasOwnProperty.call(from, key)) {
      if (_typeof(from[key]) === "object" && to[key]) {
        assign(to[key], from[key]);
      } else {
        to[key] = from[key];
      }
    }
  }
}

var config = {
  disabled: false,
  distance: 5,
  skidding: 0,
  container: "body",
  boundary: void 0,
  instantMove: false,
  disposeTimeout: 5e3,
  popperTriggers: [],
  strategy: "absolute",
  preventOverflow: true,
  flip: true,
  shift: true,
  overflowPadding: 0,
  arrowPadding: 0,
  arrowOverflow: true,
  themes: {
    tooltip: {
      placement: "top",
      triggers: ["hover", "focus", "touch"],
      hideTriggers: function hideTriggers(events) {
        return [].concat(_toConsumableArray(events), ["click"]);
      },
      delay: {
        show: 200,
        hide: 0
      },
      handleResize: false,
      html: false,
      loadingContent: "..."
    },
    dropdown: {
      placement: "bottom",
      triggers: ["click"],
      delay: 0,
      handleResize: true,
      autoHide: true
    },
    menu: {
      $extend: "dropdown",
      triggers: ["hover", "focus"],
      popperTriggers: ["hover", "focus"],
      delay: {
        show: 0,
        hide: 400
      }
    }
  }
};

function getDefaultConfig(theme, key) {
  var themeConfig = config.themes[theme] || {};
  var value;

  do {
    value = themeConfig[key];

    if (typeof value === "undefined") {
      if (themeConfig.$extend) {
        themeConfig = config.themes[themeConfig.$extend] || {};
      } else {
        themeConfig = null;
        value = config[key];
      }
    } else {
      themeConfig = null;
    }
  } while (themeConfig);

  return value;
}

function getThemeClasses(theme) {
  var result = [theme];
  var themeConfig = config.themes[theme] || {};

  do {
    if (themeConfig.$extend && !themeConfig.$resetCss) {
      result.push(themeConfig.$extend);
      themeConfig = config.themes[themeConfig.$extend] || {};
    } else {
      themeConfig = null;
    }
  } while (themeConfig);

  return result.map(function (c) {
    return "v-popper--theme-".concat(c);
  });
}

function getAllParentThemes(theme) {
  var result = [theme];
  var themeConfig = config.themes[theme] || {};

  do {
    if (themeConfig.$extend) {
      result.push(themeConfig.$extend);
      themeConfig = config.themes[themeConfig.$extend] || {};
    } else {
      themeConfig = null;
    }
  } while (themeConfig);

  return result;
}

var vueResize = "";
var supportsPassive = false;

if (typeof window !== "undefined") {
  supportsPassive = false;

  try {
    var opts = Object.defineProperty({}, "passive", {
      get: function get() {
        supportsPassive = true;
      }
    });
    window.addEventListener("test", null, opts);
  } catch (e) {}
}

var isIOS = false;

if (typeof window !== "undefined" && typeof navigator !== "undefined") {
  isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

var placements = ["auto", "top", "bottom", "left", "right"].reduce(function (acc, base) {
  return acc.concat([base, "".concat(base, "-start"), "".concat(base, "-end")]);
}, []);
var SHOW_EVENT_MAP = {
  hover: "mouseenter",
  focus: "focus",
  click: "click",
  touch: "touchstart"
};
var HIDE_EVENT_MAP = {
  hover: "mouseleave",
  focus: "blur",
  click: "click",
  touch: "touchend"
};

function removeFromArray(array, item) {
  var index = array.indexOf(item);

  if (index !== -1) {
    array.splice(index, 1);
  }
}

function nextFrame() {
  return new Promise(function (resolve) {
    return requestAnimationFrame(function () {
      requestAnimationFrame(resolve);
    });
  });
}

var shownPoppers = [];
var hidingPopper = null;
var shownPoppersByTheme = {};

function getShownPoppersByTheme(theme) {
  var list = shownPoppersByTheme[theme];

  if (!list) {
    list = shownPoppersByTheme[theme] = [];
  }

  return list;
}

var Element = function Element() {};

if (typeof window !== "undefined") {
  Element = window.Element;
}

function defaultPropFactory(prop) {
  return function (props) {
    return getDefaultConfig(props.theme, prop);
  };
}

var PROVIDE_KEY = "__floating-vue__popper";

var PrivatePopper = function PrivatePopper() {
  return defineComponent({
    name: "VPopper",
    provide: function provide() {
      return _defineProperty({}, PROVIDE_KEY, {
        parentPopper: this
      });
    },
    inject: _defineProperty({}, PROVIDE_KEY, {
      default: null
    }),
    props: {
      theme: {
        type: String,
        required: true
      },
      targetNodes: {
        type: Function,
        required: true
      },
      referenceNode: {
        type: Function,
        default: null
      },
      popperNode: {
        type: Function,
        required: true
      },
      shown: {
        type: Boolean,
        default: false
      },
      showGroup: {
        type: String,
        default: null
      },
      ariaId: {
        default: null
      },
      disabled: {
        type: Boolean,
        default: defaultPropFactory("disabled")
      },
      positioningDisabled: {
        type: Boolean,
        default: defaultPropFactory("positioningDisabled")
      },
      placement: {
        type: String,
        default: defaultPropFactory("placement"),
        validator: function validator(value) {
          return placements.includes(value);
        }
      },
      delay: {
        type: [String, Number, Object],
        default: defaultPropFactory("delay")
      },
      distance: {
        type: [Number, String],
        default: defaultPropFactory("distance")
      },
      skidding: {
        type: [Number, String],
        default: defaultPropFactory("skidding")
      },
      triggers: {
        type: Array,
        default: defaultPropFactory("triggers")
      },
      showTriggers: {
        type: [Array, Function],
        default: defaultPropFactory("showTriggers")
      },
      hideTriggers: {
        type: [Array, Function],
        default: defaultPropFactory("hideTriggers")
      },
      popperTriggers: {
        type: Array,
        default: defaultPropFactory("popperTriggers")
      },
      popperShowTriggers: {
        type: [Array, Function],
        default: defaultPropFactory("popperShowTriggers")
      },
      popperHideTriggers: {
        type: [Array, Function],
        default: defaultPropFactory("popperHideTriggers")
      },
      container: {
        type: [String, Object, Element, Boolean],
        default: defaultPropFactory("container")
      },
      boundary: {
        type: [String, Element],
        default: defaultPropFactory("boundary")
      },
      strategy: {
        type: String,
        validator: function validator(value) {
          return ["absolute", "fixed"].includes(value);
        },
        default: defaultPropFactory("strategy")
      },
      autoHide: {
        type: [Boolean, Function],
        default: defaultPropFactory("autoHide")
      },
      handleResize: {
        type: Boolean,
        default: defaultPropFactory("handleResize")
      },
      instantMove: {
        type: Boolean,
        default: defaultPropFactory("instantMove")
      },
      eagerMount: {
        type: Boolean,
        default: defaultPropFactory("eagerMount")
      },
      popperClass: {
        type: [String, Array, Object],
        default: defaultPropFactory("popperClass")
      },
      computeTransformOrigin: {
        type: Boolean,
        default: defaultPropFactory("computeTransformOrigin")
      },
      autoMinSize: {
        type: Boolean,
        default: defaultPropFactory("autoMinSize")
      },
      autoSize: {
        type: [Boolean, String],
        default: defaultPropFactory("autoSize")
      },
      autoMaxSize: {
        type: Boolean,
        default: defaultPropFactory("autoMaxSize")
      },
      autoBoundaryMaxSize: {
        type: Boolean,
        default: defaultPropFactory("autoBoundaryMaxSize")
      },
      preventOverflow: {
        type: Boolean,
        default: defaultPropFactory("preventOverflow")
      },
      overflowPadding: {
        type: [Number, String],
        default: defaultPropFactory("overflowPadding")
      },
      arrowPadding: {
        type: [Number, String],
        default: defaultPropFactory("arrowPadding")
      },
      arrowOverflow: {
        type: Boolean,
        default: defaultPropFactory("arrowOverflow")
      },
      flip: {
        type: Boolean,
        default: defaultPropFactory("flip")
      },
      shift: {
        type: Boolean,
        default: defaultPropFactory("shift")
      },
      shiftCrossAxis: {
        type: Boolean,
        default: defaultPropFactory("shiftCrossAxis")
      },
      noAutoFocus: {
        type: Boolean,
        default: defaultPropFactory("noAutoFocus")
      }
    },
    emits: ["show", "hide", "update:shown", "apply-show", "apply-hide", "close-group", "close-directive", "auto-hide", "resize", "dispose"],
    data: function data() {
      return {
        isShown: false,
        isMounted: false,
        skipTransition: false,
        classes: {
          showFrom: false,
          showTo: false,
          hideFrom: false,
          hideTo: true
        },
        result: {
          x: 0,
          y: 0,
          placement: "",
          strategy: this.strategy,
          arrow: {
            x: 0,
            y: 0,
            centerOffset: 0
          },
          transformOrigin: null
        },
        shownChildren: new Set(),
        lastAutoHide: true
      };
    },
    computed: {
      popperId: function popperId() {
        return this.ariaId != null ? this.ariaId : this.randomId;
      },
      shouldMountContent: function shouldMountContent() {
        return this.eagerMount || this.isMounted;
      },
      slotData: function slotData() {
        return {
          popperId: this.popperId,
          isShown: this.isShown,
          shouldMountContent: this.shouldMountContent,
          skipTransition: this.skipTransition,
          autoHide: typeof this.autoHide === "function" ? this.lastAutoHide : this.autoHide,
          show: this.show,
          hide: this.hide,
          handleResize: this.handleResize,
          onResize: this.onResize,
          classes: __spreadProps(__spreadValues({}, this.classes), {
            popperClass: this.popperClass
          }),
          result: this.positioningDisabled ? null : this.result,
          attrs: this.$attrs
        };
      },
      parentPopper: function parentPopper() {
        var _a;

        return (_a = this[PROVIDE_KEY]) == null ? void 0 : _a.parentPopper;
      },
      hasPopperShowTriggerHover: function hasPopperShowTriggerHover() {
        var _a, _b;

        return ((_a = this.popperTriggers) == null ? void 0 : _a.includes("hover")) || ((_b = this.popperShowTriggers) == null ? void 0 : _b.includes("hover"));
      }
    },
    watch: __spreadValues(__spreadValues({
      shown: "$_autoShowHide",
      disabled: function disabled(value) {
        if (value) {
          this.dispose();
        } else {
          this.init();
        }
      },
      container: function container() {
        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!_this.isShown) {
                    _context.next = 4;
                    break;
                  }

                  _this.$_ensureTeleport();

                  _context.next = 4;
                  return _this.$_computePosition();

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      }
    }, ["triggers", "positioningDisabled"].reduce(function (acc, prop) {
      acc[prop] = "$_refreshListeners";
      return acc;
    }, {})), ["placement", "distance", "skidding", "boundary", "strategy", "overflowPadding", "arrowPadding", "preventOverflow", "shift", "shiftCrossAxis", "flip"].reduce(function (acc, prop) {
      acc[prop] = "$_computePosition";
      return acc;
    }, {})),
    created: function created() {
      this.$_isDisposed = true;
      this.randomId = "popper_".concat([Math.random(), Date.now()].map(function (n) {
        return n.toString(36).substring(2, 10);
      }).join("_"));

      if (this.autoMinSize) {
        console.warn('[floating-vue] `autoMinSize` option is deprecated. Use `autoSize="min"` instead.');
      }

      if (this.autoMaxSize) {
        console.warn("[floating-vue] `autoMaxSize` option is deprecated. Use `autoBoundaryMaxSize` instead.");
      }
    },
    mounted: function mounted() {
      this.init();
      this.$_detachPopperNode();
    },
    activated: function activated() {
      this.$_autoShowHide();
    },
    deactivated: function deactivated() {
      this.hide();
    },
    beforeUnmount: function beforeUnmount() {
      this.dispose();
    },
    methods: {
      show: function show() {
        var _this2 = this;

        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref2$event = _ref2.event,
            event = _ref2$event === void 0 ? null : _ref2$event,
            _ref2$skipDelay = _ref2.skipDelay,
            skipDelay = _ref2$skipDelay === void 0 ? false : _ref2$skipDelay,
            _ref2$force = _ref2.force,
            force = _ref2$force === void 0 ? false : _ref2$force;

        var _a, _b;

        if (((_a = this.parentPopper) == null ? void 0 : _a.lockedChild) && this.parentPopper.lockedChild !== this) return;
        this.$_pendingHide = false;

        if (force || !this.disabled) {
          if (((_b = this.parentPopper) == null ? void 0 : _b.lockedChild) === this) {
            this.parentPopper.lockedChild = null;
          }

          this.$_scheduleShow(event, skipDelay);
          this.$emit("show");
          this.$_showFrameLocked = true;
          requestAnimationFrame(function () {
            _this2.$_showFrameLocked = false;
          });
        }

        this.$emit("update:shown", true);
      },
      hide: function hide() {
        var _this3 = this;

        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref3$event = _ref3.event,
            event = _ref3$event === void 0 ? null : _ref3$event,
            _ref3$skipDelay = _ref3.skipDelay,
            skipDelay = _ref3$skipDelay === void 0 ? false : _ref3$skipDelay;

        var _a;

        if (this.$_hideInProgress) return;

        if (this.shownChildren.size > 0) {
          this.$_pendingHide = true;
          return;
        }

        if (this.hasPopperShowTriggerHover && this.$_isAimingPopper()) {
          if (this.parentPopper) {
            this.parentPopper.lockedChild = this;
            clearTimeout(this.parentPopper.lockedChildTimer);
            this.parentPopper.lockedChildTimer = setTimeout(function () {
              if (_this3.parentPopper.lockedChild === _this3) {
                _this3.parentPopper.lockedChild.hide({
                  skipDelay: skipDelay
                });

                _this3.parentPopper.lockedChild = null;
              }
            }, 1e3);
          }

          return;
        }

        if (((_a = this.parentPopper) == null ? void 0 : _a.lockedChild) === this) {
          this.parentPopper.lockedChild = null;
        }

        this.$_pendingHide = false;
        this.$_scheduleHide(event, skipDelay);
        this.$emit("hide");
        this.$emit("update:shown", false);
      },
      init: function init() {
        var _a, _b;

        if (!this.$_isDisposed) return;
        this.$_isDisposed = false;
        this.isMounted = false;
        this.$_events = [];
        this.$_preventShow = false;
        this.$_referenceNode = (_b = (_a = this.referenceNode) == null ? void 0 : _a.call(this)) != null ? _b : this.$el;
        this.$_targetNodes = this.targetNodes().filter(function (e) {
          return e.nodeType === e.ELEMENT_NODE;
        });
        this.$_popperNode = this.popperNode();
        this.$_innerNode = this.$_popperNode.querySelector(".v-popper__inner");
        this.$_arrowNode = this.$_popperNode.querySelector(".v-popper__arrow-container");
        this.$_swapTargetAttrs("title", "data-original-title");
        this.$_detachPopperNode();

        if (this.triggers.length) {
          this.$_addEventListeners();
        }

        if (this.shown) {
          this.show();
        }
      },
      dispose: function dispose() {
        if (this.$_isDisposed) return;
        this.$_isDisposed = true;
        this.$_removeEventListeners();
        this.hide({
          skipDelay: true
        });
        this.$_detachPopperNode();
        this.isMounted = false;
        this.isShown = false;
        this.$_updateParentShownChildren(false);
        this.$_swapTargetAttrs("data-original-title", "title");
        this.$emit("dispose");
      },
      onResize: function onResize() {
        var _this4 = this;

        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!_this4.isShown) {
                    _context2.next = 4;
                    break;
                  }

                  _context2.next = 3;
                  return _this4.$_computePosition();

                case 3:
                  _this4.$emit("resize");

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      },
      $_computePosition: function $_computePosition() {
        var _this5 = this;

        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var _a, options2, isPlacementAuto, autoSize, data;

          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!(_this5.$_isDisposed || _this5.positioningDisabled)) {
                    _context3.next = 2;
                    break;
                  }

                  return _context3.abrupt("return");

                case 2:
                  options2 = {
                    strategy: _this5.strategy,
                    middleware: []
                  };

                  if (_this5.distance || _this5.skidding) {
                    options2.middleware.push(offset({
                      mainAxis: _this5.distance,
                      crossAxis: _this5.skidding
                    }));
                  }

                  isPlacementAuto = _this5.placement.startsWith("auto");

                  if (isPlacementAuto) {
                    options2.middleware.push(autoPlacement({
                      alignment: (_a = _this5.placement.split("-")[1]) != null ? _a : ""
                    }));
                  } else {
                    options2.placement = _this5.placement;
                  }

                  if (_this5.preventOverflow) {
                    if (_this5.shift) {
                      options2.middleware.push(shift({
                        padding: _this5.overflowPadding,
                        boundary: _this5.boundary,
                        crossAxis: _this5.shiftCrossAxis
                      }));
                    }

                    if (!isPlacementAuto && _this5.flip) {
                      options2.middleware.push(flip({
                        padding: _this5.overflowPadding,
                        boundary: _this5.boundary
                      }));
                    }
                  }

                  options2.middleware.push(arrow({
                    element: _this5.$_arrowNode,
                    padding: _this5.arrowPadding
                  }));

                  if (_this5.arrowOverflow) {
                    options2.middleware.push({
                      name: "arrowOverflow",
                      fn: function fn(_ref4) {
                        var placement = _ref4.placement,
                            rects = _ref4.rects,
                            middlewareData = _ref4.middlewareData;
                        var overflow;
                        var centerOffset = middlewareData.arrow.centerOffset;

                        if (placement.startsWith("top") || placement.startsWith("bottom")) {
                          overflow = Math.abs(centerOffset) > rects.reference.width / 2;
                        } else {
                          overflow = Math.abs(centerOffset) > rects.reference.height / 2;
                        }

                        return {
                          data: {
                            overflow: overflow
                          }
                        };
                      }
                    });
                  }

                  if (_this5.autoMinSize || _this5.autoSize) {
                    autoSize = _this5.autoSize ? _this5.autoSize : _this5.autoMinSize ? "min" : null;
                    options2.middleware.push({
                      name: "autoSize",
                      fn: function fn(_ref5) {
                        var rects = _ref5.rects,
                            placement = _ref5.placement,
                            middlewareData = _ref5.middlewareData;

                        var _a2;

                        if ((_a2 = middlewareData.autoSize) == null ? void 0 : _a2.skip) {
                          return {};
                        }

                        var width;
                        var height;

                        if (placement.startsWith("top") || placement.startsWith("bottom")) {
                          width = rects.reference.width;
                        } else {
                          height = rects.reference.height;
                        }

                        _this5.$_innerNode.style[autoSize === "min" ? "minWidth" : autoSize === "max" ? "maxWidth" : "width"] = width != null ? "".concat(width, "px") : null;
                        _this5.$_innerNode.style[autoSize === "min" ? "minHeight" : autoSize === "max" ? "maxHeight" : "height"] = height != null ? "".concat(height, "px") : null;
                        return {
                          data: {
                            skip: true
                          },
                          reset: {
                            rects: true
                          }
                        };
                      }
                    });
                  }

                  if (_this5.autoMaxSize || _this5.autoBoundaryMaxSize) {
                    _this5.$_innerNode.style.maxWidth = null;
                    _this5.$_innerNode.style.maxHeight = null;
                    options2.middleware.push(size({
                      boundary: _this5.boundary,
                      padding: _this5.overflowPadding,
                      apply: function apply(_ref6) {
                        var width = _ref6.width,
                            height = _ref6.height;
                        _this5.$_innerNode.style.maxWidth = width != null ? "".concat(width, "px") : null;
                        _this5.$_innerNode.style.maxHeight = height != null ? "".concat(height, "px") : null;
                      }
                    }));
                  }

                  _context3.next = 13;
                  return computePosition(_this5.$_referenceNode, _this5.$_popperNode, options2);

                case 13:
                  data = _context3.sent;
                  Object.assign(_this5.result, {
                    x: data.x,
                    y: data.y,
                    placement: data.placement,
                    strategy: data.strategy,
                    arrow: __spreadValues(__spreadValues({}, data.middlewareData.arrow), data.middlewareData.arrowOverflow)
                  });

                case 15:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      },
      $_scheduleShow: function $_scheduleShow() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        this.$_updateParentShownChildren(true);
        this.$_hideInProgress = false;
        clearTimeout(this.$_scheduleTimer);

        if (hidingPopper && this.instantMove && hidingPopper.instantMove && hidingPopper !== this.parentPopper) {
          hidingPopper.$_applyHide(true);
          this.$_applyShow(true);
          return;
        }

        if (skipDelay) {
          this.$_applyShow();
        } else {
          this.$_scheduleTimer = setTimeout(this.$_applyShow.bind(this), this.$_computeDelay("show"));
        }
      },
      $_scheduleHide: function $_scheduleHide() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (this.shownChildren.size > 0) {
          this.$_pendingHide = true;
          return;
        }

        this.$_updateParentShownChildren(false);
        this.$_hideInProgress = true;
        clearTimeout(this.$_scheduleTimer);

        if (this.isShown) {
          hidingPopper = this;
        }

        if (skipDelay) {
          this.$_applyHide();
        } else {
          this.$_scheduleTimer = setTimeout(this.$_applyHide.bind(this), this.$_computeDelay("hide"));
        }
      },
      $_computeDelay: function $_computeDelay(type) {
        var delay = this.delay;
        return parseInt(delay && delay[type] || delay || 0);
      },
      $_applyShow: function $_applyShow() {
        var _arguments = arguments,
            _this6 = this;

        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var skipTransition;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  skipTransition = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
                  clearTimeout(_this6.$_disposeTimer);
                  clearTimeout(_this6.$_scheduleTimer);
                  _this6.skipTransition = skipTransition;

                  if (!_this6.isShown) {
                    _context4.next = 6;
                    break;
                  }

                  return _context4.abrupt("return");

                case 6:
                  _this6.$_ensureTeleport();

                  _context4.next = 9;
                  return nextFrame();

                case 9:
                  _context4.next = 11;
                  return _this6.$_computePosition();

                case 11:
                  _context4.next = 13;
                  return _this6.$_applyShowEffect();

                case 13:
                  if (!_this6.positioningDisabled) {
                    _this6.$_registerEventListeners([].concat(_toConsumableArray(getScrollParents(_this6.$_referenceNode)), _toConsumableArray(getScrollParents(_this6.$_popperNode))), "scroll", function () {
                      _this6.$_computePosition();
                    });
                  }

                case 14:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))();
      },
      $_applyShowEffect: function $_applyShowEffect() {
        var _this7 = this;

        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
          var bounds, popperWrapper, parentBounds, x, y, showGroup, popover, i, _iterator2, _step2, theme;

          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (!_this7.$_hideInProgress) {
                    _context5.next = 2;
                    break;
                  }

                  return _context5.abrupt("return");

                case 2:
                  if (_this7.computeTransformOrigin) {
                    bounds = _this7.$_referenceNode.getBoundingClientRect();
                    popperWrapper = _this7.$_popperNode.querySelector(".v-popper__wrapper");
                    parentBounds = popperWrapper.parentNode.getBoundingClientRect();
                    x = bounds.x + bounds.width / 2 - (parentBounds.left + popperWrapper.offsetLeft);
                    y = bounds.y + bounds.height / 2 - (parentBounds.top + popperWrapper.offsetTop);
                    _this7.result.transformOrigin = "".concat(x, "px ").concat(y, "px");
                  }

                  _this7.isShown = true;

                  _this7.$_applyAttrsToTarget({
                    "aria-describedby": _this7.popperId,
                    "data-popper-shown": ""
                  });

                  showGroup = _this7.showGroup;

                  if (showGroup) {
                    for (i = 0; i < shownPoppers.length; i++) {
                      popover = shownPoppers[i];

                      if (popover.showGroup !== showGroup) {
                        popover.hide();
                        popover.$emit("close-group");
                      }
                    }
                  }

                  shownPoppers.push(_this7);
                  document.body.classList.add("v-popper--some-open");
                  _iterator2 = _createForOfIteratorHelper(getAllParentThemes(_this7.theme));

                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      theme = _step2.value;
                      getShownPoppersByTheme(theme).push(_this7);
                      document.body.classList.add("v-popper--some-open--".concat(theme));
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }

                  _this7.$emit("apply-show");

                  _this7.classes.showFrom = true;
                  _this7.classes.showTo = false;
                  _this7.classes.hideFrom = false;
                  _this7.classes.hideTo = false;
                  _context5.next = 18;
                  return nextFrame();

                case 18:
                  _this7.classes.showFrom = false;
                  _this7.classes.showTo = true;
                  if (!_this7.noAutoFocus) _this7.$_popperNode.focus();

                case 21:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }))();
      },
      $_applyHide: function $_applyHide() {
        var _arguments2 = arguments,
            _this8 = this;

        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
          var skipTransition, _iterator3, _step3, theme, list, disposeTime;

          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  skipTransition = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : false;

                  if (!(_this8.shownChildren.size > 0)) {
                    _context6.next = 5;
                    break;
                  }

                  _this8.$_pendingHide = true;
                  _this8.$_hideInProgress = false;
                  return _context6.abrupt("return");

                case 5:
                  clearTimeout(_this8.$_scheduleTimer);

                  if (_this8.isShown) {
                    _context6.next = 8;
                    break;
                  }

                  return _context6.abrupt("return");

                case 8:
                  _this8.skipTransition = skipTransition;
                  removeFromArray(shownPoppers, _this8);

                  if (shownPoppers.length === 0) {
                    document.body.classList.remove("v-popper--some-open");
                  }

                  _iterator3 = _createForOfIteratorHelper(getAllParentThemes(_this8.theme));

                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                      theme = _step3.value;
                      list = getShownPoppersByTheme(theme);
                      removeFromArray(list, _this8);

                      if (list.length === 0) {
                        document.body.classList.remove("v-popper--some-open--".concat(theme));
                      }
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }

                  if (hidingPopper === _this8) {
                    hidingPopper = null;
                  }

                  _this8.isShown = false;

                  _this8.$_applyAttrsToTarget({
                    "aria-describedby": void 0,
                    "data-popper-shown": void 0
                  });

                  clearTimeout(_this8.$_disposeTimer);
                  disposeTime = getDefaultConfig(_this8.theme, "disposeTimeout");

                  if (disposeTime !== null) {
                    _this8.$_disposeTimer = setTimeout(function () {
                      if (_this8.$_popperNode) {
                        _this8.$_detachPopperNode();

                        _this8.isMounted = false;
                      }
                    }, disposeTime);
                  }

                  _this8.$_removeEventListeners("scroll");

                  _this8.$emit("apply-hide");

                  _this8.classes.showFrom = false;
                  _this8.classes.showTo = false;
                  _this8.classes.hideFrom = true;
                  _this8.classes.hideTo = false;
                  _context6.next = 27;
                  return nextFrame();

                case 27:
                  _this8.classes.hideFrom = false;
                  _this8.classes.hideTo = true;

                case 29:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }))();
      },
      $_autoShowHide: function $_autoShowHide() {
        if (this.shown) {
          this.show();
        } else {
          this.hide();
        }
      },
      $_ensureTeleport: function $_ensureTeleport() {
        if (this.$_isDisposed) return;
        var container = this.container;

        if (typeof container === "string") {
          container = window.document.querySelector(container);
        } else if (container === false) {
          container = this.$_targetNodes[0].parentNode;
        }

        if (!container) {
          throw new Error("No container for popover: " + this.container);
        }

        container.appendChild(this.$_popperNode);
        this.isMounted = true;
      },
      $_addEventListeners: function $_addEventListeners() {
        var _this9 = this;

        var handleShow = function handleShow(event) {
          if (_this9.isShown && !_this9.$_hideInProgress) {
            return;
          }

          event.usedByTooltip = true;
          !_this9.$_preventShow && _this9.show({
            event: event
          });
        };

        this.$_registerTriggerListeners(this.$_targetNodes, SHOW_EVENT_MAP, this.triggers, this.showTriggers, handleShow);
        this.$_registerTriggerListeners([this.$_popperNode], SHOW_EVENT_MAP, this.popperTriggers, this.popperShowTriggers, handleShow);

        var handleHide = function handleHide(event) {
          if (event.usedByTooltip) {
            return;
          }

          _this9.hide({
            event: event
          });
        };

        this.$_registerTriggerListeners(this.$_targetNodes, HIDE_EVENT_MAP, this.triggers, this.hideTriggers, handleHide);
        this.$_registerTriggerListeners([this.$_popperNode], HIDE_EVENT_MAP, this.popperTriggers, this.popperHideTriggers, handleHide);
      },
      $_registerEventListeners: function $_registerEventListeners(targetNodes, eventType, handler) {
        this.$_events.push({
          targetNodes: targetNodes,
          eventType: eventType,
          handler: handler
        });
        targetNodes.forEach(function (node) {
          return node.addEventListener(eventType, handler, supportsPassive ? {
            passive: true
          } : void 0);
        });
      },
      $_registerTriggerListeners: function $_registerTriggerListeners(targetNodes, eventMap, commonTriggers, customTrigger, handler) {
        var _this10 = this;

        var triggers = commonTriggers;

        if (customTrigger != null) {
          triggers = typeof customTrigger === "function" ? customTrigger(triggers) : customTrigger;
        }

        triggers.forEach(function (trigger) {
          var eventType = eventMap[trigger];

          if (eventType) {
            _this10.$_registerEventListeners(targetNodes, eventType, handler);
          }
        });
      },
      $_removeEventListeners: function $_removeEventListeners(filterEventType) {
        var newList = [];
        this.$_events.forEach(function (listener) {
          var targetNodes = listener.targetNodes,
              eventType = listener.eventType,
              handler = listener.handler;

          if (!filterEventType || filterEventType === eventType) {
            targetNodes.forEach(function (node) {
              return node.removeEventListener(eventType, handler);
            });
          } else {
            newList.push(listener);
          }
        });
        this.$_events = newList;
      },
      $_refreshListeners: function $_refreshListeners() {
        if (!this.$_isDisposed) {
          this.$_removeEventListeners();
          this.$_addEventListeners();
        }
      },
      $_handleGlobalClose: function $_handleGlobalClose(event) {
        var _this11 = this;

        var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.$_showFrameLocked) return;
        this.hide({
          event: event
        });

        if (event.closePopover) {
          this.$emit("close-directive");
        } else {
          this.$emit("auto-hide");
        }

        if (touch) {
          this.$_preventShow = true;
          setTimeout(function () {
            _this11.$_preventShow = false;
          }, 300);
        }
      },
      $_detachPopperNode: function $_detachPopperNode() {
        this.$_popperNode.parentNode && this.$_popperNode.parentNode.removeChild(this.$_popperNode);
      },
      $_swapTargetAttrs: function $_swapTargetAttrs(attrFrom, attrTo) {
        var _iterator4 = _createForOfIteratorHelper(this.$_targetNodes),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var el = _step4.value;
            var value = el.getAttribute(attrFrom);

            if (value) {
              el.removeAttribute(attrFrom);
              el.setAttribute(attrTo, value);
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      },
      $_applyAttrsToTarget: function $_applyAttrsToTarget(attrs) {
        var _iterator5 = _createForOfIteratorHelper(this.$_targetNodes),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var el = _step5.value;

            for (var n in attrs) {
              var value = attrs[n];

              if (value == null) {
                el.removeAttribute(n);
              } else {
                el.setAttribute(n, value);
              }
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      },
      $_updateParentShownChildren: function $_updateParentShownChildren(value) {
        var parent = this.parentPopper;

        while (parent) {
          if (value) {
            parent.shownChildren.add(this.randomId);
          } else {
            parent.shownChildren.delete(this.randomId);

            if (parent.$_pendingHide) {
              parent.hide();
            }
          }

          parent = parent.parentPopper;
        }
      },
      $_isAimingPopper: function $_isAimingPopper() {
        var referenceBounds = this.$_referenceNode.getBoundingClientRect();

        if (mouseX >= referenceBounds.left && mouseX <= referenceBounds.right && mouseY >= referenceBounds.top && mouseY <= referenceBounds.bottom) {
          var popperBounds = this.$_popperNode.getBoundingClientRect();
          var vectorX = mouseX - mousePreviousX;
          var vectorY = mouseY - mousePreviousY;
          var distance = popperBounds.left + popperBounds.width / 2 - mousePreviousX + (popperBounds.top + popperBounds.height / 2) - mousePreviousY;
          var newVectorLength = distance + popperBounds.width + popperBounds.height;
          var edgeX = mousePreviousX + vectorX * newVectorLength;
          var edgeY = mousePreviousY + vectorY * newVectorLength;
          return lineIntersectsLine(mousePreviousX, mousePreviousY, edgeX, edgeY, popperBounds.left, popperBounds.top, popperBounds.left, popperBounds.bottom) || lineIntersectsLine(mousePreviousX, mousePreviousY, edgeX, edgeY, popperBounds.left, popperBounds.top, popperBounds.right, popperBounds.top) || lineIntersectsLine(mousePreviousX, mousePreviousY, edgeX, edgeY, popperBounds.right, popperBounds.top, popperBounds.right, popperBounds.bottom) || lineIntersectsLine(mousePreviousX, mousePreviousY, edgeX, edgeY, popperBounds.left, popperBounds.bottom, popperBounds.right, popperBounds.bottom);
        }

        return false;
      }
    },
    render: function render() {
      return this.$slots.default(this.slotData);
    }
  });
};

if (typeof document !== "undefined" && typeof window !== "undefined") {
  if (isIOS) {
    document.addEventListener("touchstart", handleGlobalMousedown, supportsPassive ? {
      passive: true,
      capture: true
    } : true);
    document.addEventListener("touchend", handleGlobalTouchend, supportsPassive ? {
      passive: true,
      capture: true
    } : true);
  } else {
    window.addEventListener("mousedown", handleGlobalMousedown, true);
    window.addEventListener("click", handleGlobalClick, true);
  }

  window.addEventListener("resize", computePositionAllShownPoppers);
}

function handleGlobalMousedown(event) {
  for (var i = 0; i < shownPoppers.length; i++) {
    var popper = shownPoppers[i];

    try {
      var popperContent = popper.popperNode();
      popper.$_mouseDownContains = popperContent.contains(event.target);
    } catch (e) {}
  }
}

function handleGlobalClick(event) {
  handleGlobalClose(event);
}

function handleGlobalTouchend(event) {
  handleGlobalClose(event, true);
}

function handleGlobalClose(event) {
  var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var preventClose = {};

  var _loop = function _loop(i) {
    var popper = shownPoppers[i];

    try {
      var contains = popper.$_containsGlobalTarget = isContainingEventTarget(popper, event);
      popper.$_pendingHide = false;
      requestAnimationFrame(function () {
        popper.$_pendingHide = false;
        if (preventClose[popper.randomId]) return;

        if (shouldAutoHide(popper, contains, event)) {
          popper.$_handleGlobalClose(event, touch);

          if (!event.closeAllPopover && event.closePopover && contains) {
            var parent2 = popper.parentPopper;

            while (parent2) {
              preventClose[parent2.randomId] = true;
              parent2 = parent2.parentPopper;
            }

            return;
          }

          var parent = popper.parentPopper;

          while (parent) {
            if (shouldAutoHide(parent, parent.$_containsGlobalTarget, event)) {
              parent.$_handleGlobalClose(event, touch);
            } else {
              break;
            }

            parent = parent.parentPopper;
          }
        }
      });
    } catch (e) {}
  };

  for (var i = shownPoppers.length - 1; i >= 0; i--) {
    _loop(i);
  }
}

function isContainingEventTarget(popper, event) {
  var popperContent = popper.popperNode();
  return popper.$_mouseDownContains || popperContent.contains(event.target);
}

function shouldAutoHide(popper, contains, event) {
  return event.closeAllPopover || event.closePopover && contains || getAutoHideResult(popper, event) && !contains;
}

function getAutoHideResult(popper, event) {
  if (typeof popper.autoHide === "function") {
    var result = popper.autoHide(event);
    popper.lastAutoHide = result;
    return result;
  }

  return popper.autoHide;
}

function computePositionAllShownPoppers(event) {
  for (var i = 0; i < shownPoppers.length; i++) {
    var popper = shownPoppers[i];
    popper.$_computePosition(event);
  }
}

function hideAllPoppers() {
  for (var i = 0; i < shownPoppers.length; i++) {
    var popper = shownPoppers[i];
    popper.hide();
  }
}

var mousePreviousX = 0;
var mousePreviousY = 0;
var mouseX = 0;
var mouseY = 0;

if (typeof window !== "undefined") {
  window.addEventListener("mousemove", function (event) {
    mousePreviousX = mouseX;
    mousePreviousY = mouseY;
    mouseX = event.clientX;
    mouseY = event.clientY;
  }, supportsPassive ? {
    passive: true
  } : void 0);
}

function lineIntersectsLine(x1, y1, x2, y2, x3, y3, x4, y4) {
  var uA = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / ((y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1));
  var uB = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / ((y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1));
  return uA >= 0 && uA <= 1 && uB >= 0 && uB <= 1;
}

var _export_sfc = function _export_sfc(sfc, props) {
  var target = sfc.__vccOpts || sfc;

  var _iterator6 = _createForOfIteratorHelper(props),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var _ref9 = _step6.value;

      var _ref8 = _slicedToArray(_ref9, 2);

      var key = _ref8[0];
      var val = _ref8[1];
      target[key] = val;
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  return target;
};

var _sfc_main$6 = {
  extends: PrivatePopper()
};

function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: "reference",
    class: normalizeClass(["v-popper", {
      "v-popper--shown": _ctx.slotData.isShown
    }])
  }, [renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps(_ctx.slotData)))], 2);
}

var Popper$1 = /* @__PURE__ */_export_sfc(_sfc_main$6, [["render", _sfc_render$3]]);

function getInternetExplorerVersion() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");

  if (msie > 0) {
    return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
  }

  var trident = ua.indexOf("Trident/");

  if (trident > 0) {
    var rv = ua.indexOf("rv:");
    return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
  }

  var edge = ua.indexOf("Edge/");

  if (edge > 0) {
    return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
  }

  return -1;
}

var isIE;

function initCompat() {
  if (!initCompat.init) {
    initCompat.init = true;
    isIE = getInternetExplorerVersion() !== -1;
  }
}

var script = {
  name: "ResizeObserver",
  props: {
    emitOnMount: {
      type: Boolean,
      default: false
    },
    ignoreWidth: {
      type: Boolean,
      default: false
    },
    ignoreHeight: {
      type: Boolean,
      default: false
    }
  },
  emits: ["notify"],
  mounted: function mounted() {
    var _this12 = this;

    initCompat();
    nextTick(function () {
      _this12._w = _this12.$el.offsetWidth;
      _this12._h = _this12.$el.offsetHeight;

      if (_this12.emitOnMount) {
        _this12.emitSize();
      }
    });
    var object = document.createElement("object");
    this._resizeObject = object;
    object.setAttribute("aria-hidden", "true");
    object.setAttribute("tabindex", -1);
    object.onload = this.addResizeHandlers;
    object.type = "text/html";

    if (isIE) {
      this.$el.appendChild(object);
    }

    object.data = "about:blank";

    if (!isIE) {
      this.$el.appendChild(object);
    }
  },
  beforeUnmount: function beforeUnmount() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify: function compareAndNotify() {
      if (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) {
        this._w = this.$el.offsetWidth;
        this._h = this.$el.offsetHeight;
        this.emitSize();
      }
    },
    emitSize: function emitSize() {
      this.$emit("notify", {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers: function addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify);

      this.compareAndNotify();
    },
    removeResizeHandlers: function removeResizeHandlers() {
      if (this._resizeObject && this._resizeObject.onload) {
        if (!isIE && this._resizeObject.contentDocument) {
          this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify);
        }

        this.$el.removeChild(this._resizeObject);
        this._resizeObject.onload = null;
        this._resizeObject = null;
      }
    }
  }
};

var _withId = /* @__PURE__ */withScopeId("data-v-b329ee4c");

pushScopeId("data-v-b329ee4c");
var _hoisted_1$2 = {
  class: "resize-observer",
  tabindex: "-1"
};
popScopeId();

var render = /* @__PURE__ */_withId(function (_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("div", _hoisted_1$2);
});

script.render = render;
script.__scopeId = "data-v-b329ee4c";
script.__file = "src/components/ResizeObserver.vue";

var PrivateThemeClass = function PrivateThemeClass() {
  var prop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "theme";
  return {
    computed: {
      themeClass: function themeClass() {
        return getThemeClasses(this[prop]);
      }
    }
  };
};

var PopperContent_vue_vue_type_style_index_0_lang = "";

var _sfc_main$5 = defineComponent({
  name: "VPopperContent",
  components: {
    ResizeObserver: script
  },
  mixins: [PrivateThemeClass()],
  props: {
    popperId: String,
    theme: String,
    shown: Boolean,
    mounted: Boolean,
    skipTransition: Boolean,
    autoHide: Boolean,
    handleResize: Boolean,
    classes: Object,
    result: Object
  },
  emits: ["hide", "resize"],
  methods: {
    toPx: function toPx(value) {
      if (value != null && !isNaN(value)) {
        return "".concat(value, "px");
      }

      return null;
    }
  }
});

var _hoisted_1$1 = ["id", "aria-hidden", "tabindex", "data-popper-placement"];
var _hoisted_2$1 = {
  ref: "inner",
  class: "v-popper__inner"
};

var _hoisted_3 = /* @__PURE__ */createElementVNode("div", {
  class: "v-popper__arrow-outer"
}, null, -1);

var _hoisted_4 = /* @__PURE__ */createElementVNode("div", {
  class: "v-popper__arrow-inner"
}, null, -1);

var _hoisted_5 = [_hoisted_3, _hoisted_4];

function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ResizeObserver = resolveComponent("ResizeObserver");

  return openBlock(), createElementBlock("div", {
    id: _ctx.popperId,
    ref: "popover",
    class: normalizeClass(["v-popper__popper", [_ctx.themeClass, _ctx.classes.popperClass, {
      "v-popper__popper--shown": _ctx.shown,
      "v-popper__popper--hidden": !_ctx.shown,
      "v-popper__popper--show-from": _ctx.classes.showFrom,
      "v-popper__popper--show-to": _ctx.classes.showTo,
      "v-popper__popper--hide-from": _ctx.classes.hideFrom,
      "v-popper__popper--hide-to": _ctx.classes.hideTo,
      "v-popper__popper--skip-transition": _ctx.skipTransition,
      "v-popper__popper--arrow-overflow": _ctx.result && _ctx.result.arrow.overflow,
      "v-popper__popper--no-positioning": !_ctx.result
    }]]),
    style: normalizeStyle(_ctx.result ? {
      position: _ctx.result.strategy,
      transform: "translate3d(".concat(Math.round(_ctx.result.x), "px,").concat(Math.round(_ctx.result.y), "px,0)")
    } : void 0),
    "aria-hidden": _ctx.shown ? "false" : "true",
    tabindex: _ctx.autoHide ? 0 : void 0,
    "data-popper-placement": _ctx.result ? _ctx.result.placement : void 0,
    onKeyup: _cache[2] || (_cache[2] = withKeys(function ($event) {
      return _ctx.autoHide && _ctx.$emit("hide");
    }, ["esc"]))
  }, [createElementVNode("div", {
    class: "v-popper__backdrop",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.autoHide && _ctx.$emit("hide");
    })
  }), createElementVNode("div", {
    class: "v-popper__wrapper",
    style: normalizeStyle(_ctx.result ? {
      transformOrigin: _ctx.result.transformOrigin
    } : void 0)
  }, [createElementVNode("div", _hoisted_2$1, [_ctx.mounted ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [createElementVNode("div", null, [renderSlot(_ctx.$slots, "default")]), _ctx.handleResize ? (openBlock(), createBlock(_component_ResizeObserver, {
    key: 0,
    onNotify: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.$emit("resize", $event);
    })
  })) : createCommentVNode("", true)], 64)) : createCommentVNode("", true)], 512), createElementVNode("div", {
    ref: "arrow",
    class: "v-popper__arrow-container",
    style: normalizeStyle(_ctx.result ? {
      left: _ctx.toPx(_ctx.result.arrow.x),
      top: _ctx.toPx(_ctx.result.arrow.y)
    } : void 0)
  }, _hoisted_5, 4)], 4)], 46, _hoisted_1$1);
}

var PrivatePopperContent = /* @__PURE__ */_export_sfc(_sfc_main$5, [["render", _sfc_render$2]]);

var PrivatePopperMethods = {
  methods: {
    show: function show() {
      var _this$$refs$popper;

      return (_this$$refs$popper = this.$refs.popper).show.apply(_this$$refs$popper, arguments);
    },
    hide: function hide() {
      var _this$$refs$popper2;

      return (_this$$refs$popper2 = this.$refs.popper).hide.apply(_this$$refs$popper2, arguments);
    },
    dispose: function dispose() {
      var _this$$refs$popper3;

      return (_this$$refs$popper3 = this.$refs.popper).dispose.apply(_this$$refs$popper3, arguments);
    },
    onResize: function onResize() {
      var _this$$refs$popper4;

      return (_this$$refs$popper4 = this.$refs.popper).onResize.apply(_this$$refs$popper4, arguments);
    }
  }
};

var _sfc_main$4 = defineComponent({
  name: "VPopperWrapper",
  components: {
    Popper: Popper$1,
    PopperContent: PrivatePopperContent
  },
  mixins: [PrivatePopperMethods, PrivateThemeClass("finalTheme")],
  props: {
    theme: {
      type: String,
      default: null
    }
  },
  computed: {
    finalTheme: function finalTheme() {
      var _a;

      return (_a = this.theme) != null ? _a : this.$options.vPopperTheme;
    }
  },
  methods: {
    getTargetNodes: function getTargetNodes() {
      var _this13 = this;

      return Array.from(this.$el.children).filter(function (node) {
        return node !== _this13.$refs.popperContent.$el;
      });
    }
  }
});

function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_PopperContent = resolveComponent("PopperContent");

  var _component_Popper = resolveComponent("Popper");

  return openBlock(), createBlock(_component_Popper, {
    ref: "popper",
    theme: _ctx.finalTheme,
    "target-nodes": _ctx.getTargetNodes,
    "popper-node": function popperNode() {
      return _ctx.$refs.popperContent.$el;
    },
    class: normalizeClass([_ctx.themeClass])
  }, {
    default: withCtx(function (_ref10) {
      var popperId = _ref10.popperId,
          isShown = _ref10.isShown,
          shouldMountContent = _ref10.shouldMountContent,
          skipTransition = _ref10.skipTransition,
          autoHide = _ref10.autoHide,
          show = _ref10.show,
          hide = _ref10.hide,
          handleResize = _ref10.handleResize,
          onResize = _ref10.onResize,
          classes = _ref10.classes,
          result = _ref10.result;
      return [renderSlot(_ctx.$slots, "default", {
        shown: isShown,
        show: show,
        hide: hide
      }), createVNode(_component_PopperContent, {
        ref: "popperContent",
        "popper-id": popperId,
        theme: _ctx.finalTheme,
        shown: isShown,
        mounted: shouldMountContent,
        "skip-transition": skipTransition,
        "auto-hide": autoHide,
        "handle-resize": handleResize,
        classes: classes,
        result: result,
        onHide: hide,
        onResize: onResize
      }, {
        default: withCtx(function () {
          return [renderSlot(_ctx.$slots, "popper", {
            shown: isShown,
            hide: hide
          })];
        }),
        _: 2
      }, 1032, ["popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])];
    }),
    _: 3
  }, 8, ["theme", "target-nodes", "popper-node", "class"]);
}

var PrivatePopperWrapper = /* @__PURE__ */_export_sfc(_sfc_main$4, [["render", _sfc_render$1]]);

var Dropdown_vue_vue_type_style_index_0_lang = "";

var _sfc_main$3 = defineComponent(__spreadProps(__spreadValues({}, PrivatePopperWrapper), {
  name: "VDropdown",
  vPopperTheme: "dropdown"
}));

var _sfc_main$2 = defineComponent(__spreadProps(__spreadValues({}, PrivatePopperWrapper), {
  name: "VMenu",
  vPopperTheme: "menu"
}));

var Tooltip_vue_vue_type_style_index_0_lang = "";

var _sfc_main$1 = defineComponent(__spreadProps(__spreadValues({}, PrivatePopperWrapper), {
  name: "VTooltip",
  vPopperTheme: "tooltip"
}));

var _sfc_main = defineComponent({
  name: "VTooltipDirective",
  components: {
    Popper: PrivatePopper(),
    PopperContent: PrivatePopperContent
  },
  mixins: [PrivatePopperMethods],
  inheritAttrs: false,
  props: {
    theme: {
      type: String,
      default: "tooltip"
    },
    html: {
      type: Boolean,
      default: function _default(props) {
        return getDefaultConfig(props.theme, "html");
      }
    },
    content: {
      type: [String, Number, Function],
      default: null
    },
    loadingContent: {
      type: String,
      default: function _default(props) {
        return getDefaultConfig(props.theme, "loadingContent");
      }
    }
  },
  data: function data() {
    return {
      asyncContent: null
    };
  },
  computed: {
    isContentAsync: function isContentAsync() {
      return typeof this.content === "function";
    },
    loading: function loading() {
      return this.isContentAsync && this.asyncContent == null;
    },
    finalContent: function finalContent() {
      if (this.isContentAsync) {
        return this.loading ? this.loadingContent : this.asyncContent;
      }

      return this.content;
    }
  },
  watch: {
    content: {
      handler: function handler() {
        this.fetchContent(true);
      },
      immediate: true
    },
    finalContent: function finalContent() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this14.$nextTick();

              case 2:
                _this14.$refs.popper.onResize();

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    }
  },
  created: function created() {
    this.$_fetchId = 0;
  },
  methods: {
    fetchContent: function fetchContent(force) {
      var _this15 = this;

      if (typeof this.content === "function" && this.$_isShown && (force || !this.$_loading && this.asyncContent == null)) {
        this.asyncContent = null;
        this.$_loading = true;
        var fetchId = ++this.$_fetchId;
        var result = this.content(this);

        if (result.then) {
          result.then(function (res) {
            return _this15.onResult(fetchId, res);
          });
        } else {
          this.onResult(fetchId, result);
        }
      }
    },
    onResult: function onResult(fetchId, result) {
      if (fetchId !== this.$_fetchId) return;
      this.$_loading = false;
      this.asyncContent = result;
    },
    onShow: function onShow() {
      this.$_isShown = true;
      this.fetchContent();
    },
    onHide: function onHide() {
      this.$_isShown = false;
    }
  }
});

var _hoisted_1 = ["innerHTML"];
var _hoisted_2 = ["textContent"];

function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_PopperContent = resolveComponent("PopperContent");

  var _component_Popper = resolveComponent("Popper");

  return openBlock(), createBlock(_component_Popper, mergeProps({
    ref: "popper"
  }, _ctx.$attrs, {
    theme: _ctx.theme,
    "popper-node": function popperNode() {
      return _ctx.$refs.popperContent.$el;
    },
    onApplyShow: _ctx.onShow,
    onApplyHide: _ctx.onHide
  }), {
    default: withCtx(function (_ref11) {
      var popperId = _ref11.popperId,
          isShown = _ref11.isShown,
          shouldMountContent = _ref11.shouldMountContent,
          skipTransition = _ref11.skipTransition,
          autoHide = _ref11.autoHide,
          hide = _ref11.hide,
          handleResize = _ref11.handleResize,
          onResize = _ref11.onResize,
          classes = _ref11.classes,
          result = _ref11.result;
      return [createVNode(_component_PopperContent, {
        ref: "popperContent",
        class: normalizeClass({
          "v-popper--tooltip-loading": _ctx.loading
        }),
        "popper-id": popperId,
        theme: _ctx.theme,
        shown: isShown,
        mounted: shouldMountContent,
        "skip-transition": skipTransition,
        "auto-hide": autoHide,
        "handle-resize": handleResize,
        classes: classes,
        result: result,
        onHide: hide,
        onResize: onResize
      }, {
        default: withCtx(function () {
          return [_ctx.html ? (openBlock(), createElementBlock("div", {
            key: 0,
            innerHTML: _ctx.finalContent
          }, null, 8, _hoisted_1)) : (openBlock(), createElementBlock("div", {
            key: 1,
            textContent: toDisplayString(_ctx.finalContent)
          }, null, 8, _hoisted_2))];
        }),
        _: 2
      }, 1032, ["class", "popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])];
    }),
    _: 1
  }, 16, ["theme", "popper-node", "onApplyShow", "onApplyHide"]);
}

var PrivateTooltipDirective = /* @__PURE__ */_export_sfc(_sfc_main, [["render", _sfc_render]]);

var TARGET_CLASS = "v-popper--has-tooltip";

function getPlacement(options2, modifiers) {
  var result = options2.placement;

  if (!result && modifiers) {
    var _iterator7 = _createForOfIteratorHelper(placements),
        _step7;

    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var pos = _step7.value;

        if (modifiers[pos]) {
          result = pos;
        }
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
  }

  if (!result) {
    result = getDefaultConfig(options2.theme || "tooltip", "placement");
  }

  return result;
}

function getOptions(el, value, modifiers) {
  var options2;

  var type = _typeof(value);

  if (type === "string") {
    options2 = {
      content: value
    };
  } else if (value && type === "object") {
    options2 = value;
  } else {
    options2 = {
      content: false
    };
  }

  options2.placement = getPlacement(options2, modifiers);

  options2.targetNodes = function () {
    return [el];
  };

  options2.referenceNode = function () {
    return el;
  };

  return options2;
}

var directiveApp;
var directives;
var uid = 0;

function ensureDirectiveApp() {
  if (directiveApp) return;
  directives = ref([]);
  directiveApp = createApp({
    name: "VTooltipDirectiveApp",
    setup: function setup() {
      return {
        directives: directives
      };
    },
    render: function render() {
      return this.directives.map(function (directive) {
        return h(PrivateTooltipDirective, __spreadProps(__spreadValues({}, directive.options), {
          shown: directive.shown || directive.options.shown,
          key: directive.id
        }));
      });
    },
    devtools: {
      hide: true
    }
  });
  var mountTarget = document.createElement("div");
  document.body.appendChild(mountTarget);
  directiveApp.mount(mountTarget);
}

function createTooltip(el, value, modifiers) {
  ensureDirectiveApp();
  var options2 = ref(getOptions(el, value, modifiers));
  var shown = ref(false);
  var item = {
    id: uid++,
    options: options2,
    shown: shown
  };
  directives.value.push(item);

  if (el.classList) {
    el.classList.add(TARGET_CLASS);
  }

  var result = el.$_popper = {
    options: options2,
    item: item,
    show: function show() {
      shown.value = true;
    },
    hide: function hide() {
      shown.value = false;
    }
  };
  return result;
}

function destroyTooltip(el) {
  if (el.$_popper) {
    var index = directives.value.indexOf(el.$_popper.item);
    if (index !== -1) directives.value.splice(index, 1);
    delete el.$_popper;
    delete el.$_popperOldShown;
    delete el.$_popperMountTarget;
  }

  if (el.classList) {
    el.classList.remove(TARGET_CLASS);
  }
}

function bind(el, _ref12) {
  var value = _ref12.value,
      modifiers = _ref12.modifiers;
  var options2 = getOptions(el, value, modifiers);

  if (!options2.content || getDefaultConfig(options2.theme || "tooltip", "disabled")) {
    destroyTooltip(el);
  } else {
    var directive;

    if (el.$_popper) {
      directive = el.$_popper;
      directive.options.value = options2;
    } else {
      directive = createTooltip(el, value, modifiers);
    }

    if (typeof value.shown !== "undefined" && value.shown !== el.$_popperOldShown) {
      el.$_popperOldShown = value.shown;
      value.shown ? directive.show() : directive.hide();
    }
  }
}

var PrivateVTooltip = {
  beforeMount: bind,
  updated: bind,
  beforeUnmount: function beforeUnmount(el) {
    destroyTooltip(el);
  }
};

function addListeners(el) {
  el.addEventListener("click", onClick);
  el.addEventListener("touchstart", onTouchStart, supportsPassive ? {
    passive: true
  } : false);
}

function removeListeners(el) {
  el.removeEventListener("click", onClick);
  el.removeEventListener("touchstart", onTouchStart);
  el.removeEventListener("touchend", onTouchEnd);
  el.removeEventListener("touchcancel", onTouchCancel);
}

function onClick(event) {
  var el = event.currentTarget;
  event.closePopover = !el.$_vclosepopover_touch;
  event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
}

function onTouchStart(event) {
  if (event.changedTouches.length === 1) {
    var el = event.currentTarget;
    el.$_vclosepopover_touch = true;
    var touch = event.changedTouches[0];
    el.$_vclosepopover_touchPoint = touch;
    el.addEventListener("touchend", onTouchEnd);
    el.addEventListener("touchcancel", onTouchCancel);
  }
}

function onTouchEnd(event) {
  var el = event.currentTarget;
  el.$_vclosepopover_touch = false;

  if (event.changedTouches.length === 1) {
    var touch = event.changedTouches[0];
    var firstTouch = el.$_vclosepopover_touchPoint;
    event.closePopover = Math.abs(touch.screenY - firstTouch.screenY) < 20 && Math.abs(touch.screenX - firstTouch.screenX) < 20;
    event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
  }
}

function onTouchCancel(event) {
  var el = event.currentTarget;
  el.$_vclosepopover_touch = false;
}

var PrivateVClosePopper = {
  beforeMount: function beforeMount(el, _ref13) {
    var value = _ref13.value,
        modifiers = _ref13.modifiers;
    el.$_closePopoverModifiers = modifiers;

    if (typeof value === "undefined" || value) {
      addListeners(el);
    }
  },
  updated: function updated(el, _ref14) {
    var value = _ref14.value,
        oldValue = _ref14.oldValue,
        modifiers = _ref14.modifiers;
    el.$_closePopoverModifiers = modifiers;

    if (value !== oldValue) {
      if (typeof value === "undefined" || value) {
        addListeners(el);
      } else {
        removeListeners(el);
      }
    }
  },
  beforeUnmount: function beforeUnmount(el) {
    removeListeners(el);
  }
};
var options = config;
var VTooltip = PrivateVTooltip;
var VClosePopper = PrivateVClosePopper;
var Dropdown = _sfc_main$3;
var Menu = _sfc_main$2;
var Popper = PrivatePopper;
var PopperContent = PrivatePopperContent;
var PopperMethods = PrivatePopperMethods;
var PopperWrapper = PrivatePopperWrapper;
var ThemeClass = PrivateThemeClass;
var Tooltip = _sfc_main$1;
var TooltipDirective = PrivateTooltipDirective;

function install(app) {
  var options2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (app.$_vTooltipInstalled) return;
  app.$_vTooltipInstalled = true;
  assign(config, options2);
  app.directive("tooltip", PrivateVTooltip);
  app.directive("close-popper", PrivateVClosePopper);
  app.component("VTooltip", _sfc_main$1);
  app.component("VDropdown", _sfc_main$3);
  app.component("VMenu", _sfc_main$2);
}

var plugin = {
  version: "2.0.0-beta.20",
  install: install,
  options: config
};
export { Dropdown, HIDE_EVENT_MAP, Menu, Popper, PopperContent, PopperMethods, PopperWrapper, SHOW_EVENT_MAP, ThemeClass, Tooltip, TooltipDirective, VClosePopper, VTooltip, createTooltip, plugin as default, destroyTooltip, hideAllPoppers, install, options, placements };